import { createContext, useState } from "react";
import { formatDate } from "../../../../utils/formatDate";

const TriagemContratoContext = createContext();

const TriagemContratoContextProvider = ({ children }) => {
  const [customerProposals, setCustomerProposals] = useState([]);

  const [singleFirstInstallment, setSingleFirstInstallment] = useState("");
  const [singleServiceType, setSingleServiceType] = useState(null);
  const [singleRegimeCompetence, setSingleRegimeCompetence] = useState(null);
  const [singleCompetenceDate, setSingleCompetenceDate] = useState("mm/aaaa");
  const [singleBank, setSingleBank] = useState(null);
  const [singlePaymentType, setSinglePaymentType] = useState(null);
  const [singlePaymentWay, setSinglePaymentWay] = useState(null);
  const [singleSlipType, setSingleSlipType] = useState(null);
  const [singleNfse, setSingleNfse] = useState(true);
  const [singleBillingRuler, setSingleBillingRuler] = useState(null);

  const [recurrentServiceType, setRecurrentServiceType] = useState(null);
  const [recurrentFirstMonthlyDate, setRecurrentFirstMonthlyDate] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [recurrentExpirationDay, setRecurrentExpirationDay] = useState("");
  const [recurrentReadjustment, setRecurrentReadjustment] = useState(null);
  const [recurrentRegimeCompetence, setRecurrentRegimeCompetence] =
    useState(null);
  const [recurrentCompetenceDate, setRecurrentCompetenceDate] =
    useState("mm/aaaa");
  const [recurrentValidityDate, setRecurrentValidityDate] = useState("mm/aaaa");
  const [recurrentBank, setRecurrentBank] = useState(null);
  const [recurrentPaymentType, setRecurrentPaymentType] = useState(null);
  const [recurrentFrequency, setRecurrentFrequency] = useState(null);
  const [recurrentSlipType, setRecurrentSlipType] = useState(null);
  const [recurrentNfse, setRecurrentNfse] = useState(true);
  const [recurrentBillingRuler, setRecurrentBillingRuler] = useState(null);

  const [proposalCode, setProposalCode] = useState("");
  const [revisionDate, setRevisionDate] = useState("");
  const [contractTypeList, setContractTypeList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [readjustmentList, setReadjustmentList] = useState([]);
  const [paymentWayList, setPaymentWayList] = useState([]);
  const [billingRulerList, setBillingRulerList] = useState([]);
  const [rowEdit, setRowEdit] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingsInputs, setLoadingsInputs] = useState({});
  const [originProposal, setOriginProposal] = useState("");
  const [financialResponsibleEnabled, setFinancialResponsibleEnabled] =
    useState(false);
  const [financialResponsibleInfos, setFinancialResponsibleInfos] =
    useState(null);
  const [leadOrigin, setLeadOrigin] = useState(null);
  const [listLeadOrigin, setListLeadOrigin] = useState([]);
  const [saleType, setSaleType] = useState(null);
  const [listSaleType, setListSaleType] = useState([]);
  const [salesmanInfos, setSalesmanInfos] = useState(null);
  const [generatedInstallments, setGeneratedInstallments] = useState([]);

  const variablesModule = {
    ERP_QYON: {
      AGENCIA_QYON_BANK_ID: 63,
      TIPO_PAGAMENTO_BOLETO_ID: 11,
      TIPO_BOLETO_CNAB_ID: 0,
      TIPO_REAJUSTE_IGMPAC12_ID: 1,
      TIPO_PAGAMENTO_1X_ID: 133,
    },
  };

  return (
    <TriagemContratoContext.Provider
      value={{
        customerProposals,
        setCustomerProposals,

        singleFirstInstallment,
        setSingleFirstInstallment,
        singleServiceType,
        setSingleServiceType,
        singleRegimeCompetence,
        setSingleRegimeCompetence,
        singleCompetenceDate,
        setSingleCompetenceDate,
        singleBank,
        setSingleBank,
        singlePaymentType,
        setSinglePaymentType,
        singlePaymentWay,
        setSinglePaymentWay,
        singleSlipType,
        setSingleSlipType,
        singleNfse,
        setSingleNfse,
        singleBillingRuler,
        setSingleBillingRuler,

        recurrentServiceType,
        setRecurrentServiceType,
        recurrentFirstMonthlyDate,
        setRecurrentFirstMonthlyDate,
        recurrentExpirationDay,
        setRecurrentExpirationDay,
        recurrentReadjustment,
        setRecurrentReadjustment,
        recurrentRegimeCompetence,
        setRecurrentRegimeCompetence,
        recurrentCompetenceDate,
        setRecurrentCompetenceDate,
        recurrentValidityDate,
        setRecurrentValidityDate,
        recurrentBank,
        setRecurrentBank,
        recurrentPaymentType,
        setRecurrentPaymentType,
        recurrentFrequency,
        setRecurrentFrequency,
        recurrentSlipType,
        setRecurrentSlipType,
        recurrentNfse,
        setRecurrentNfse,
        recurrentBillingRuler,
        setRecurrentBillingRuler,

        proposalCode,
        setProposalCode,
        revisionDate,
        setRevisionDate,
        contractTypeList,
        setContractTypeList,
        serviceList,
        setServiceList,
        bankList,
        setBankList,
        paymentTypeList,
        setPaymentTypeList,
        readjustmentList,
        setReadjustmentList,
        paymentWayList,
        setPaymentWayList,
        billingRulerList,
        setBillingRulerList,
        rowEdit,
        setRowEdit,
        errors,
        setErrors,
        variablesModule,
        loading,
        setLoading,
        loadingsInputs,
        setLoadingsInputs,

        originProposal,
        setOriginProposal,
        financialResponsibleEnabled,
        setFinancialResponsibleEnabled,
        financialResponsibleInfos,
        setFinancialResponsibleInfos,
        leadOrigin,
        setLeadOrigin,
        listLeadOrigin,
        setListLeadOrigin,
        saleType,
        setSaleType,
        listSaleType,
        setListSaleType,
        salesmanInfos,
        setSalesmanInfos,
        generatedInstallments,
        setGeneratedInstallments,
      }}
    >
      {children}
    </TriagemContratoContext.Provider>
  );
};

export { TriagemContratoContext, TriagemContratoContextProvider };
